import { z } from "zod";

// Query-string serialization collapses a single-element array to a scalar,
// so wrap a lone id back into an array.
export const zQueryUuidArray = () =>
    z.preprocess(
        (value) => (typeof value === "string" ? [value] : value),
        z.array(z.string().uuid()),
    );
